import { ImagesSquareIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useIntl } from "react-intl";

import { LazyImage } from "@/components/Image/LazyImage";
import { ImageCarousel } from "@/components/ImageCarousel/ImageCarousel";
import { HotelGalleryIndicators } from "@/features/hotels/components/hotel/HotelGalleryIndicators";

type HotelGalleryInlineProps = {
  images: string[];
  hotelName: string;
  onClick?: () => void;
};

export const HotelGalleryInline = ({
  images,
  hotelName,
  onClick,
}: HotelGalleryInlineProps) => {
  const intl = useIntl();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (images.length === 0) {
    return (
      <div className="flex aspect-[35/24] items-center justify-center rounded-t-2xl bg-gray-100 text-xs text-gray-400">
        {intl.formatMessage({
          defaultMessage: "No image available",
          description: "Placeholder text when no hotel images are available",
        })}
      </div>
    );
  }

  return (
    <div className="relative w-full overflow-hidden rounded-t-2xl">
      <ImageCarousel
        items={images}
        loop={false}
        getItemKey={(url) => url}
        onSlideChange={setCurrentIndex}
        className="aspect-[35/24]"
        slideClassName="h-full"
        slides={{ perView: 1, spacing: 0, origin: "auto" }}
        renderItem={(url, idx) => (
          <button type="button" onClick={onClick} className="h-full w-full">
            <LazyImage
              src={url}
              alt={`${hotelName} ${idx + 1}`}
              className="h-full w-full object-cover"
            />
          </button>
        )}
      />

      {images.length > 1 && (
        <div className="absolute end-3 bottom-3 flex items-center justify-center gap-1 rounded-full bg-black/26 px-2.5 py-1.5 text-center text-white">
          <span className="text-sm font-medium">{images.length}</span>
          <ImagesSquareIcon size={16} />
        </div>
      )}

      <HotelGalleryIndicators
        totalImages={images.length}
        currentIndex={currentIndex}
      />
    </div>
  );
};
